import { PDFDocument, StandardFonts, rgb } from "pdf-lib";
export const usePDF = () => {
  const download = (pdfBytes: Uint8Array, fileName: string) => {
    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    const link = document.createElement("a");
    link.target = "_blank";
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(link.href);
  };

  async function createRecoveryKitPdf(email: string, password: string) {
    const { sourcesUrl } = useRuntimeConfig().public;
    const url = `${sourcesUrl}/marketplace/recovery_kit.pdf`;
    const existingPdfBytes = await fetch(url).then((res) => res.arrayBuffer());

    const pdfDoc = await PDFDocument.load(existingPdfBytes);

    const form = pdfDoc.getForm();

    const emailField = form.getTextField("email_field");
    const passwordField = form.getTextField("recoverykey_field");
    const dateField = form.getTextField("date_field");
    emailField.setText(email);
    passwordField.setText(password);
    dateField.setText(
      "Created on " +
        new Date().toLocaleDateString("en-US", {
          month: "long",
          day: "numeric",
          year: "numeric",
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
        }) +
        ` by ${window.location.origin}`
    );
    form.flatten();

    const pdfBytes = await pdfDoc.save();
    download(pdfBytes, `${email}-recovery-kit.pdf`);
  }

  async function createReferralsReportPdf(
    startDate: string,
    endDate: string,
    creationDate: string,
    name: string,
    email: string,
    gfalId: string,
    marketplaceAmountGFAL: number,
    marketplacePercentage: number,
    inGameAmountUSD: number,
    ingamePercentage: number,
    conversionRate: number,
    conversionRateDate: string
  ) {
    const { sourcesUrl } = useRuntimeConfig().public;
    const url = `${sourcesUrl}/marketplace/monthlyreport.pdf`;
    const existingPdfBytes = await fetch(url).then((res) => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    const form = pdfDoc.getForm();
    form.getTextField("start_date").setText(startDate.split("T")[0]);
    form.getTextField("end_date").setText(endDate.split("T")[0]);
    //form.getTextField("creation_date").setText(creationDate.split("T")[0]);
    form.getTextField("username_field").setText(name);
    form.getTextField("email_field").setText(email);
    form.getTextField("gfalid_field").setText(gfalId);

    let EARNED_USD = (inGameAmountUSD * (ingamePercentage)) / 100;
    let EARNED_GFAL = (marketplaceAmountGFAL * (marketplacePercentage)) / 100;

    form.getTextField("referrals_ingame_field 2").setText(inGameAmountUSD.toString() + " USD");
    form.getTextField("ingame_percentage_field 2").setText(ingamePercentage.toString() + "%");
    form.getTextField("flauta_trompeta 4").setText(EARNED_USD.toLocaleString("en-US", { minimumFractionDigits: 1, maximumFractionDigits: 6 }) + " USD");
    form.getTextField("referrals_marketplace_field").setText(marketplaceAmountGFAL.toString() + " GFAL");
    form.getTextField("marketplace_percentage_field").setText(marketplacePercentage.toString() + "%");
    form.getTextField("flauta_trompeta 2").setText(EARNED_GFAL.toLocaleString("en-US", { minimumFractionDigits: 1, maximumFractionDigits: 8 }) + " GFAL");
    //form
    //  .getTextField("flauta_trompeta")
    //  .setText(totalGFAL.toString() + " GFAL");
    //form.getTextField("total_usd_field").setText(totalUSD.toString() + " USD");
    //form
    //  .getTextField("conversion_rate")
    //  .setText(conversionRate.toString() + " GFAL");
    form.getTextField("date").setText(conversionRateDate.split("T")[0]);
    form.flatten();
    const pdfBytes = await pdfDoc.save();
    download(pdfBytes, `referrals-report-${creationDate.split("T")[0]}.pdf`);
  }

  async function createReferralsInvoicePdf(
    headerField1_LegalName: string,
    headerField2_TaxAddress: string,
    headerField3_TaxId: string,
    invoiceDate: string,
    invoiceNumber: string,
    description: string,
    inGameAmountUSD: number,
    notes: string,
    email: string
  ) {
    const { sourcesUrl } = useRuntimeConfig().public;
    const url = `${sourcesUrl}/marketplace/referralinvoice.pdf`;
    const existingPdfBytes = await fetch(url).then((res) => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    const form = pdfDoc.getForm();
    
    let total_usd = inGameAmountUSD;
    let subtotal_usd = inGameAmountUSD;

    form.getTextField("legal_name").setText(headerField1_LegalName);
    form.getTextField("tax_address").setText(headerField2_TaxAddress);
    form.getTextField("tax_id").setText(headerField3_TaxId);
    form.getTextField("invoice_date").setText(invoiceDate.split("T")[0]);
    form.getTextField("invoice_number").setText(invoiceNumber);
    form.getTextField("description").setText(description);
    form.getTextField("usd_amount").setText(inGameAmountUSD.toString() + " USD");
    form.getTextField("total_usd").setText(total_usd.toString() + " USD");
    form.getTextField("subtotal_usd").setText(subtotal_usd.toString() + " USD");
    form.getTextField("notes").setText(notes);
    form.getTextField("wallet_address").setText("Payment will be sent via Paypal to:" + email);

    form.flatten();
    const pdfBytes = await pdfDoc.save();
    download(pdfBytes, `invoice-report-${invoiceDate.split("T")[0]}.pdf`);
  }

  return { createRecoveryKitPdf, createReferralsReportPdf, createReferralsInvoicePdf };
};
